import { Card } from "react-bootstrap";

const ProfileInformation = ({ employee }) => {
  if (!employee) return null;

  return (
    <Card className="bg-white border-0 rounded-3 mb-4">
      <Card.Body className="p-4">
        <h3 className="mb-3 mb-lg-4">Profile Information</h3>

        <ul className="ps-0 mb-0 list-unstyled">
          <li className="d-flex align-items-center mb-2">
            <span>Full Name:</span>
            <span className="text-secondary fw-medium ms-1">
              {employee.name}
            </span>
          </li>

          <li className="d-flex align-items-center mb-2">
            <span>Email:</span>
            <span className="text-secondary fw-medium ms-1">
              {employee.email || "—"}
            </span>
          </li>

          <li className="d-flex align-items-center mb-2">
            <span>Role:</span>
            <span className="text-secondary fw-medium ms-1">
              {employee.role || "Member"}
            </span>
          </li>

          <li className="d-flex align-items-center">
            <span>Status:</span>
            <span className="text-secondary fw-medium ms-1">
              Active
            </span>
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
};

export default ProfileInformation;
